import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import { ToastProvider } from './context/ToastContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from 'react-hot-toast';
import AppRoutes from './routes';
import { tokenManager } from './utils/tokenManager';

function App() {
  // Start token monitoring when app loads
  React.useEffect(() => {
    tokenManager.startAuthMonitoring();

    // Cleanup on unmount
    return () => {
      tokenManager.stopMonitoring();
    };
  }, []);

  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppProvider>
          <AuthProvider>
            <ToastProvider>
              <AppRoutes />
              <Toaster position="top-right" />
            </ToastProvider>
          </AuthProvider>
        </AppProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
